export const GET_MATURED_PENSION_API_REQUEST = 'GET_MATURED_PENSION_API_REQUEST';
export const GET_MATURED_PENSION_API_SUCCESS = 'GET_MATURED_PENSION_API_SUCCESS';
export const GET_MATURED_PENSION_API_ERROR = 'GET_MATURED_PENSION_API_ERROR';
